<template>
  <footer class="footer-type01">
    <div class="container">
      <div class="row">
        <ul class="footer-widget">
          <li class="widget-about">
            <h4 class="footerheading">about <span>soccer club</span></h4>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Blanditiis vitae, velit perferendis dolor atque magni, porro minus
              repellendus nostrum alias ea deserunt. Vel quam explicabo
              laudantium accusamus est, nulla minima!
            </p>

            <p>
              <span class="uppercaseheading">address:</span
              ><span class="red">239</span> main street London,England.
            </p>

            <p>
              <span class="uppercaseheading">call:</span>
              <span class="red">1800-2222-3333</span>
            </p>
          </li>
          <li class="widget-news">
            <h4 class="footerheading">recent <span>news</span></h4>
            <ul class="widget-newsdetails clearfix">
              <li class="clearfix">
                <a href="#" class="clearfix">
                  <div
                    class="widget-pic"
                    :style="{
                      background: `url(${widgetImage}) center no-repeat`,
                    }"
                  ></div>
                  <div class="widget-newsinfo">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Numquam soluta excepturi.
                    </p>

                    <p class="uppercaseheading">
                      18 september ,<span class="red">2015</span>
                    </p>
                  </div>
                </a>
              </li>
              <li class="clearfix">
                <a href="#" class="clearfix">
                  <div
                    class="widget-pic"
                    :style="{
                      background: `url(${widgetImage}) center no-repeat`,
                    }"
                  ></div>
                  <div class="widget-newsinfo">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Numquam soluta excepturi.
                    </p>

                    <p class="uppercaseheading">
                      18 september ,<span class="red">2015</span>
                    </p>
                  </div>
                </a>
              </li>
              <li class="clearfix">
                <a href="#" class="clearfix">
                  <div
                    class="widget-pic"
                    :style="{
                      background: `url(${widgetImage}) center no-repeat`,
                    }"
                  ></div>
                  <div class="widget-newsinfo">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Numquam soluta excepturi.
                    </p>

                    <p class="uppercaseheading">
                      18 september ,<span class="red">2015</span>
                    </p>
                  </div>
                </a>
              </li>
            </ul>
          </li>
          <li class="widget-product">
            <h4 class="footerheading">real <span>soccer products</span></h4>
            <ul class="widget_productdetails">
              <li><a href="#">shoes(4)</a></li>
              <li><a href="#">men(4)</a></li>
              <li><a href="#">t-shirt(4)</a></li>
              <li><a href="#">sports(4)</a></li>
              <li><a href="#">glass</a></li>
            </ul>
          </li>
          <li class="widget-comment">
            <h4 class="footerheading">recent <span>comments</span></h4>
            <ul class="widget_commentDetails">
              <li>
                <a href="#" class="clearfix">
                  <div class="comment-pic">
                    <div class="columnpic">
                      <img
                        src="@/assets/images/widget/comment01.jpg"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div class="commentinfo">
                    <p class="uppercaseheading">jhon doe</p>

                    <p>18 April ,<span class="red">2015</span></p>

                    <p>nice and cool</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="#" class="clearfix">
                  <div class="comment-pic">
                    <div class="columnpic">
                      <img
                        src="@/assets/images/widget/comment02.jpg"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div class="commentinfo">
                    <p class="uppercaseheading">jhon doe</p>

                    <p>18 April ,<span class="red">2015</span></p>

                    <p>nice and cool</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="#" class="clearfix">
                  <div class="comment-pic">
                    <div class="columnpic">
                      <img
                        src="@/assets/images/widget/comment03.jpg"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div class="commentinfo">
                    <p class="uppercaseheading">jhon doe</p>

                    <p>18 April ,<span class="red">2015</span></p>

                    <p>nice and cool</p>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-type02">
      <div class="container">
        <div class="row">
          <a href="/" class="footer-logo"
            ><img src="@/assets/images/logo/logo-youtube.png" alt="image"
          /></a>

          <div class="footer-container">
            <ul class="clearfix">
              <li>
                <a
                  href="https://www.facebook.com/templatespoint.net"
                  class="bigsocial-link"
                  ><i class="fa fa-facebook"></i
                ></a>
              </li>
              <li>
                <a
                  href="https://twitter.com/"
                  class="bigsocial-link"
                  target="_blank"
                  ><i class="fa fa-twitter"></i
                ></a>
              </li>
              <li>
                <a
                  href="https://www.behance.net/"
                  class="bigsocial-link"
                  target="_blank"
                  ><i class="fa fa-behance"></i
                ></a>
              </li>
            </ul>
            <p>
              <a target="_blank" href="">Tim 11 Social Media</a>
            </p>
          </div>
          <div class="footer-appstore">
            <figure>
              <a href="#"
                ><img src="@/assets/images/appstore/apple.png" alt="image"
              /></a>
            </figure>
            <figure>
              <a href="#"
                ><img src="@/assets/images/appstore/google.png" alt="image"
              /></a>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import widgetImage from "@/assets/images/widget/widget03.jpg";
/*
const news = [
  {
    id: 1,
    image: "/images/widget/widget01.jpg",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam soluta excepturi.",
    date: "18 September",
    year: "2015",
  },
  {
    id: 2,
    image: "/images/widget/widget02.jpg",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam soluta excepturi.",
    date: "18 September",
    year: "2015",
  },
  {
    id: 3,
    image: "/images/widget/widget03.jpg",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam soluta excepturi.",
    date: "18 September",
    year: "2015",
  },
];

const products = ["shoes (4)", "men (4)", "t-shirt (4)", "sports (4)", "glass"];

const comments = [
  {
    id: 1,
    name: "Jhon Doe",
    date: "18 April",
    year: "2015",
    text: "Nice and cool",
    image: "/images/widget/comment01.jpg",
  },
  {
    id: 2,
    name: "Jhon Doe",
    date: "18 April",
    year: "2015",
    text: "Nice and cool",
    image: "/images/widget/comment02.jpg",
  },
  {
    id: 3,
    name: "Jhon Doe",
    date: "18 April",
    year: "2015",
    text: "Nice and cool",
    image: "/images/widget/comment03.jpg",
  },
];
*/
</script>

<style scoped>
.footer-type01 {
  background: #111;
  color: #ccc;
  padding: 60px 0;
  font-size: 14px;
}

.footerheading {
  text-transform: uppercase;
  color: white;
  margin-bottom: 1rem;
}

.footerheading span {
  color: #e21e1e;
}

.red {
  color: #e21e1e;
}

.footer-type02 {
  background: #000;
  color: #aaa;
  text-align: center;
  padding: 20px 0;
}

.footer-type02 .footer-logo img {
  width: 100px;
  margin-bottom: 10px;
}
</style>
